import React from "react";
import jwtDecode from "jwt-decode";
import { BrowserRouter, Route, Switch, Redirect, Link } from "react-router-dom";
import WithTracker from "../containers/Analytics/Analytics";
import Loadable from "react-loadable";
import { connect } from "react-redux";

import Loader from "../_components/Loader/Loader";

import { ROOT_URL, USER_FETCH_URL } from "../constants/constant";

//GLOBAL STYLES USING STYLED COMPONENTS
import GlobalStyles from "../commonStyledComonents/GlobalStyles.js";

import CookieConsent from "react-cookie-consent";
import CollaboratorNetworkProfileContainer from "../_containers/CollaboratorNetworkProfileContainer/CollaboratorNetworkProfileContainer";


const SpainSocialMedia =  Loadable({
  loader: () => import("../_components/Application/SocialMedia/Spain/SocialMediaSpain"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const PatentNew =  Loadable({
  loader: () => import("../_components/PatentsMainSearch"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

// const PatentsMap =  Loadable({
//   loader: () => import("../_components/PatentsMap"),
//   loading: () => (
//     <div>
//       <Loader />
//     </div>
//   ),
// });

const SpainSocialMediaEsl = Loadable({
  loader: () => import("../_components/Application/SocialMedia/Spain/EslChart"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});


const SpainSocialMediaProfile =  Loadable({
  loader: () => import("../_components/Application/SocialMedia/Spain/ProfileView"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});


const Login = Loadable({
  loader: () => import("../containers/Login/Login"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const ResetPassword = Loadable({
  loader: () => import("../containers/Signup/ResetPassword"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});



const ForgetPassword = Loadable({
  loader: () => import("../containers/Signup/ForgetPassword"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const Register = Loadable({
  loader: () => import("../containers/Signup/Register"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RegisterInfo = Loadable({
  loader: () => import("../containers/Signup/RegisterInfo"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const PrivacyPolicy = Loadable({
  loader: () => import("../containers/PrivacyPolicy/PrivacyPolicy"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RotaApplication = Loadable({
  loader: () => import("../_components/RotaApplicationNew"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RotaLanding = Loadable({
  loader: () => import("../_components/RotaDoctors"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RotaApplicationClinician = Loadable({
  loader: () => import("../_components/RotaApplicationNew/Clinician"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RotaApplicationOnCallActivity = Loadable({
  loader: () => import("../_components/RotaApplicationNew/OnCallActivity"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RotaApplicationLeaveDetails = Loadable({
  loader: () => import("../_components/RotaApplicationNew/LeaveDetails"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RotaApplicationTimeTable = Loadable({
  loader: () => import("../_components/RotaApplicationNew/TimeTable"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RotaApplicationRequestDetails = Loadable({
  loader: () =>
    import("../_components/RotaApplicationNew/Requests/RequestsDetails"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RotaApplicationRequestPreview = Loadable({
  loader: () =>
    import("../_components/RotaApplicationNew/Requests/RequestPreview"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RotaApplicationRequests = Loadable({
  loader: () => import("../_components/RotaApplicationNew/Requests"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RocketPharmaLad = Loadable({
  loader: () => import("../_components/RocketPharma/Lad"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RocketPharmaDanon = Loadable({
  loader: () => import("../_components/RocketPharma/Danon"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RocketPharmaDanonMBodies = Loadable({
  loader: () => import("../_components/RocketPharma/Danon/MBodies"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RocketPharmaDanonConf = Loadable({
  loader: () => import("../_components/RocketPharma/Danon/Conf"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RocketPharmaLadMBodies = Loadable({
  loader: () => import("../_components/RocketPharma/Lad/MBodies"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RocketPharmaLadTopics = Loadable({
  loader: () => import("../_components/RocketPharma/Lad/Definitions"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RocketPharmaDanonTopics = Loadable({
  loader: () => import("../_components/RocketPharma/Danon/Definitions"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RocketPharmaLadConf = Loadable({
  loader: () => import("../_components/RocketPharma/Lad/Conf"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const RocketPharmaCros = Loadable({
  loader: () => import("../_components/RocketPharma/Cros"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const AlacritaLgmd2c = Loadable({
  loader: () => import("../_components/Alacrita/LGMD2C"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const AlacritaEpidemiology = Loadable({
  loader: () => import("../_components/Alacrita/Epidemiology"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const AlacritaDefinition = Loadable({
  loader: () => import("../_components/Alacrita/LGMD2C/Definitions"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const AlacritaTrials = Loadable({
  loader: () => import("../_components/Alacrita/MainTrials"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const AlacritaTrialSites = Loadable({
  loader: () => import("../_components/Alacrita/TrialSites"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const ConceptMapping = Loadable({
  loader: () => import("../_components/ConceptMapping"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const ServicePolicy = Loadable({
  loader: () => import("../containers/PrivacyPolicy/ServicePolicy"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const GDBR = Loadable({
  loader: () => import("../containers/PrivacyPolicy/GDBR"),
  loading: () => (
    <div>
      {" "}
      <Loader />
    </div>
  ),
});

const TermsOfService = Loadable({
  loader: () => import("../containers/PrivacyPolicy/TermsOfService"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const ResonableUsePolicy = Loadable({
  loader: () => import("../containers/PrivacyPolicy/ResonableUsePolicy"),
  loading: () => (
    <div>
      {" "}
      <Loader />
    </div>
  ),
});

const CookiePolicy = Loadable({
  loader: () => import("../containers/PrivacyPolicy/CookiePolicy"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const NewHome = Loadable({
  loader: () => import("../containers/NewHome/NewHome"),
  loading: () => (
    <div>
      {" "}
      <Loader />
    </div>
  ),
});

//new
const ExpertsContainer = Loadable({
  loader: () => import("../_components/MainSearch"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const LocationContainer = Loadable({
  loader: () => import("../_components/LocationNew"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const LocationExpertsTable = Loadable({
  loader: () => import("../_components/LocationNew/ExpertsTable"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ClinicalTrialContainer = Loadable({
  loader: () =>
    import("../_containers/ClinicalTrialContainer/ClinicalTrialContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CollaboratorNetworkContainer = Loadable({
  loader: () =>
    import(
      "../_containers/CollaboratorNetworkContainer/CollaboratorNetworkContainer"
    ),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ProfileBasedCollabsNetwork = Loadable({
  loader: () =>
    import("../_components/CollaboratorNetwork/ProfileBasedCollabsNetwork"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ExpertBioContainer = Loadable({
  loader: () => import("../_containers/ExpertBioContainer/ExpertBioContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AffBioContainer = Loadable({
  loader: () =>
    import("../_containers/AffProfileNewContainer/AffProfileNewContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const TopicContainer = Loadable({
  loader: () => import("../_containers/TopicContainer/TopicContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const SocMedContainer = Loadable({
  loader: () => import("../_containers/SocMedContainer/SocMedContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});
//Absract keyword container route

const AbstractKeywordContainer = Loadable({
  loader: () =>
    import("../_containers/AbstractKeyword/AbstractKeywordContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

//Organisations container
const OrganisationsContainer = Loadable({
  loader: () =>
    import("../_containers/OrganisationsContainer/OrganisationsContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ProfileSearchContainer = Loadable({
  loader: () =>
    import("../_containers/ProfileSearchContainer/ProfileSearchContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const SeniorityProfileContainer = Loadable({
  loader: () =>
    import("../_containers/SeniorityProfileContainer/ProfileSearchContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const SenioritySchemaContainer = Loadable({
  loader: () =>
    import("../_containers/SeniorySchemaContainer/ProfileSearchContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ProfileSearchCollabContainer = Loadable({
  loader: () =>
    import("../_containers/CollabProfileContainer/ProfileSearchContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});
const UserContainer = Loadable({
  loader: () => import("../_containers/UserContainer/UserContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AffiliationBasedProfileContainer = Loadable({
  loader: () =>
    import(
      "../_containers/AffiliationBasedProfileContainer/AffiliationBasedProfileContainer"
    ),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const RegisterContainer = Loadable({
  loader: () => import("../_containers/RegisterContainer/RegisterContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const LoginContainer = Loadable({
  loader: () => import("../_containers/LoginContainer/LoginContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ExpertMultiSearchContainer = Loadable({
  loader: () => import("../_containers/ExpertMultiSearchContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const InstituteContainer = Loadable({
  loader: () => import("../_components/AffiliationSearch"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AffTrials = Loadable({
  loader: () =>
    import("../_containers/AffiliationTrialsContainer/ProfileSearchContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const DirectProfile = Loadable({
  loader: () => import("../_components/DirectProfileSearch"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const GrantsContainer = Loadable({
  loader: () => import("../_components/GrantsNew"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldProfessionals = Loadable({
  loader: () => import("../_components/MldProfessionalsNew"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldMedicalBodies = Loadable({
  loader: () => import("../_components/MldMedicalBodies"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const EventsNetwork = Loadable({
  loader: () => import("../_components/EventsNetwork"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasMedicalBodies = Loadable({
  loader: () => import("../_components/Was/MedicalBodies"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasCollabNetwork = Loadable({
  loader: () => import("../_components/Was/CollabNetwork"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasDashboard = Loadable({
  loader: () => import("../_components/Was/WasDashboard"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldLocations = Loadable({
  loader: () => import("../_components/MldLocations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldLocationsSummary = Loadable({
  loader: () => import("../_components/MldLocations/Summary"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldSocial = Loadable({
  loader: () =>
    import("../_containers/MldSocialContainer/ProfileSearchContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldConf = Loadable({
  loader: () =>
    import("../_containers/MldConfContainer/ProfileSearchContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldTrials = Loadable({
  loader: () => import("../_containers/mldClinicalTrialContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldDashboard = Loadable({
  loader: () => import("../_components/Mld/MldDashboard"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldShortList = Loadable({
  loader: () => import("../_components/MldProfessionals/ShortListedExperts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldRemovedShortList = Loadable({
  loader: () => import("../_components/MldProfessionals/RemovedShortList"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppSpecificHomePage = Loadable({
  loader: () => import("../_components/AppSpecificNavBar/HomePage"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldSelectedList = Loadable({
  loader: () => import("../_components/MldProfessionals/SelectedListExperts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldAffiliations = Loadable({
  loader: () => import("../_components/MldAffiliations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const KolMapping = Loadable({
  loader: () => import("../_components/KolMapping"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const KolUpload = Loadable({
  loader: () => import("../_components/KolMapping/Upload"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const LoginRedirect = Loadable({
  loader: () => import("../_components/LoginRedirect"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const Trials = Loadable({
  loader: () => import("../_components/Trials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const TrialsEndPoints = Loadable({
  loader: () => import("../_components/Trials/EndPoints"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MainTrials = Loadable({
  loader: () => import("../_components/Trials/MainTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const TrialSites = Loadable({
  loader: () => import("../_components/Trials/TrialSites"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const TrialsPhases = Loadable({
  loader: () => import("../_components/Trials/PhasesAndDrugs"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldCollbsNetwork = Loadable({
  loader: () => import("../_components/MldCollbsNetwork"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CountryWiseTrials = Loadable({
  loader: () => import("../_components/MldClinicalTrials/CountryWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ExpertsWiseTrials = Loadable({
  loader: () => import("../_components/MldClinicalTrials/ExpertsWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const InstituteWiseTrials = Loadable({
  loader: () => import("../_components/MldClinicalTrials/InstituteWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldDefinition = Loadable({
  loader: () => import("../_components/MldDefinition"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldSummary = Loadable({
  loader: () => import("../_components/MldDefinition/Summary"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldSocialMedia = Loadable({
  loader: () => import("../_components/Mld/SocialMedia"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptProfessionals = Loadable({
  loader: () => import("../_components/NiptProfessionals"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptShortList = Loadable({
  loader: () => import("../_components/NiptProfessionals/ShortListedExperts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptSelectedList = Loadable({
  loader: () => import("../_components/NiptProfessionals/SelectedListExperts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptAffiliations = Loadable({
  loader: () => import("../_components/NiptAffiliations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptLocations = Loadable({
  loader: () => import("../_components/NiptLocations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptLocationsSummary = Loadable({
  loader: () => import("../_components/NiptLocations/Summary"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptCollbsNetwork = Loadable({
  loader: () => import("../_components/NiptCollbsNetwork"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptDefinition = Loadable({
  loader: () => import("../_components/NiptDefinition"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptSummary = Loadable({
  loader: () => import("../_components/NiptDefinition/Summary"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptTrials = Loadable({
  loader: () => import("../_containers/NiptappClinicalTrialContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptCountryWiseTrials = Loadable({
  loader: () => import("../_components/NiptClinicalTrials/CountryWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptExpertsWiseTrials = Loadable({
  loader: () => import("../_components/NiptClinicalTrials/ExpertsWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptInstituteWiseTrials = Loadable({
  loader: () => import("../_components/NiptClinicalTrials/InstituteWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptGrants = Loadable({
  loader: () => import("../_components/NiptGrants"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const RelatedConcepts = Loadable({
  loader: () => import("../_components/RelatedConcepts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const PeerReviewer = Loadable({
  loader: () => import("../_components/PeerReviewer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const RotaDoctorsMyDetails = Loadable({
  loader: () => import("../_components/RotaDoctors/MyDetails"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const RotaDoctorsClinicList = Loadable({
  loader: () => import("../_components/RotaDoctors/ClinicList"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const RotaDoctorsTimeTable = Loadable({
  loader: () => import("../_components/RotaDoctors/TimeTable"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const RotaDoctorsOnCallList = Loadable({
  loader: () => import("../_components/RotaDoctors/OnCallList"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const RotaDoctorsLeaveList = Loadable({
  loader: () => import("../_components/RotaDoctors/LeaveList"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ExpertProfile = Loadable({
  loader: () => import("../_components/ExpertProfile"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptMedicalBodies = Loadable({
  loader: () => import("../_components/NiptApp/MedicalBodies"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptConf = Loadable({
  loader: () => import("../_components/NiptApp/Conf"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptFundingOrg = Loadable({
  loader: () => import("../_components/NiptApp/FundingOrg"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const PersonSimilarity = Loadable({
  loader: () => import("../_components/PersonSimilarity"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldTweetsSummary = Loadable({
  loader: () => import("../_components/MldTweets/Summary"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldTweetsRelatedTerms = Loadable({
  loader: () => import("../_components/MldTweets/RelatedTerms"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldTweetsRelatedUsers = Loadable({
  loader: () => import("../_components/MldTweets/RelatedUsers"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldTweetsSentiment = Loadable({
  loader: () => import("../_components/MldTweets/Sentiment"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldTweetsUsers = Loadable({
  loader: () => import("../_components/MldTweets/Users"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MldTweetsHandler = Loadable({
  loader: () => import("../_components/MldTweets/TweetHandler"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const Help = Loadable({
  loader: () => import("../_components/Help"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});
const Sources = Loadable({
  loader: () => import("../_components/DbSources"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const Landing = Loadable({
  loader: () => import("../_components/Application/Landing"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const Contacts = Loadable({
  loader: () => import("../_components/Application/Contacts"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

// const UserTracker = Loadable({
//   loader: () => import("../_components/UserTracker"),
//   loading: () => (
//     <div>
//       <Loader />
//     </div>
//   )
// })

// const UserTrackerPlayer = Loadable({
//   loader: () => import("../_components/UserTracker/Player"),
//   loading: () => (
//     <div>
//       <Loader />
//     </div>
//   )
// })

const WasDefinitions = Loadable({
  loader: () => import("../_components/Was/WasDefinitions"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const WasSummary = Loadable({
  loader: () => import("../_components/Was/WasDefinitions/Summary"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const GeneralTweetsUsers = Loadable({
  loader: () => import("../_components/GeneralTweets/Users"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const GeneralTweetsHandler = Loadable({
  loader: () => import("../_components/GeneralTweets/TweetHandler"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasExperts = Loadable({
  loader: () => import("../_components/Was/WasExperts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasLocationsSummary = Loadable({
  loader: () => import("../_components/Was/WasLocations/Summary"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasAffiliations = Loadable({
  loader: () => import("../_components/Was/WasAffiliations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasCountryWiseTrials = Loadable({
  loader: () =>
    import("../_components/Was/WasClinicalTrials/CountryWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasExpertsWiseTrials = Loadable({
  loader: () =>
    import("../_components/Was/WasClinicalTrials/ExpertsWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasInstituteWiseTrials = Loadable({
  loader: () =>
    import("../_components/Was/WasClinicalTrials/InstituteWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasTrials = Loadable({
  loader: () => import("../_containers/WasClinicalTrialContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasConfs = Loadable({
  loader: () => import("../_components/Was/WasConfs"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasTweetsHandler = Loadable({
  loader: () => import("../_components/Was/WasSocialMedia/TweetHandler"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const WasTweetsUsers = Loadable({
  loader: () => import("../_components/Was/WasSocialMedia/Users"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ErnNetwork = Loadable({
  loader: () => import("../_components/ErnNetwork"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const MyAccount = Loadable({
  loader: () => import("../_components/MyAccount"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

/** NEW NIPT PAGES */
const NiptAppExperts = Loadable({
  loader: () => import("../_components/NiptApp/Experts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptAppAffiliations = Loadable({
  loader: () => import("../_components/NiptApp/Affiliations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptAppLocations = Loadable({
  loader: () => import("../_components/NiptApp/Locations/Summary"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptappDefinitions = Loadable({
  loader: () => import("../_components/NiptApp/Definitions"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const NiptappSummary = Loadable({
  loader: () => import("../_components/NiptApp/Definitions/Summary"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const NiptappCollabNetwork = Loadable({
  loader: () => import("../_components/NiptApp/CollabNetwork"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptappCountryWiseTrials = Loadable({
  loader: () =>
    import("../_components/NiptApp/ClinicalTrials/CountryWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptappExpertsWiseTrials = Loadable({
  loader: () =>
    import("../_components/NiptApp/ClinicalTrials/ExpertsWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptappInstituteWiseTrials = Loadable({
  loader: () =>
    import("../_components/NiptApp/ClinicalTrials/InstituteWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NiptappTrials = Loadable({
  loader: () => import("../_containers/NiptappClinicalTrialContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppHome = Loadable({
  loader: () => import("../_components/Mld/MldHome"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

//============================================= zognix routers goes here ===========================
const AppExpertSummary = Loadable({
  loader: () => import("../_containers/Applications/Stakeholders"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppExpertSummaryTop = Loadable({
  loader: () => import("../_containers/Applications/Stakeholders/Top100"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppExpertSummaryAll =  Loadable({
  loader: () => import("../_containers/Applications/StakeholdersAll"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ZognixDashboard = Loadable({
  loader: () => import("../_components/zognix/Dashboard"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});
const AppSocialMedia = Loadable({
  // loader: () => import("../_components/zognix/SocialMedia"),
  loader: () => import("../_containers/Applications/SocialMedia"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppMedicalBodies = Loadable({
  loader: () => import("../_containers/Applications/MedicalBodies"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});


const AppMedicalSociety = Loadable({
  loader: () => import("../_containers/Applications/MedicalBodies/MedicalSociety"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});


const AppPatientAdvocacy = Loadable({
  loader: () => import("../_containers/Applications/MedicalBodies/PatientAdvocacy"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppCollabNetwork = Loadable({
  // loader: () => import("../_components/zognix/CollabNetwork"),
  loader: () => import("../_containers/Applications/Network"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ZognixExperts = Loadable({
  loader: () => import("../_components/Application/Experts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppLocationsSummary = Loadable({
  // loader: () => import("../_components/zognix/WasLocations/Summary"),
  loader: () => import("../_containers/Applications/Locations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppAffiliations = Loadable({
  // loader: () => import("../_components/zognix/WasAffiliations"),
  loader: () => import("../_containers/Applications/Affiliations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ZognixCountryWiseTrials = Loadable({
  loader: () =>
    import("../_components/zognix/WasClinicalTrials/CountryWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ZognixExpertsWiseTrials = Loadable({
  loader: () =>
    import("../_components/zognix/WasClinicalTrials/ExpertsWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ZognixInstituteWiseTrials = Loadable({
  loader: () =>
    import("../_components/zognix/WasClinicalTrials/InstituteWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ZognixTrials = Loadable({
  loader: () => import("../_containers/ZognixClinicalTrialContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppCongresses = Loadable({
  // loader: () => import("../_containers/ZognixConfContainer"),
  loader: () => import("../_containers/Applications/Congresses"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ZognixTweetsHandler = Loadable({
  loader: () => import("../_components/zognix/WasSocialMedia/TweetHandler"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ZognixTweetsUsers = Loadable({
  loader: () => import("../_components/zognix/WasSocialMedia/Users"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppDefinitions = Loadable({
  // loader: () => import("../_components/zognix/WasDefinitions"),
  loader: () => import("../_containers/Applications/Definitions"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

// const ZognixSpecialtyCenter = Loadable({
//   loader: () => import("../_components/zognix/SpecialtyCenter/Center"),
//   loading: () => (
//     <div>
//       <Loader />
//     </div>
//   ),
// });

const ZognixSpecialtyCenterTable = Loadable({
  loader: () => import("../_components/zognix/SpecialtyCenter/Center/Table"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const ZognixSpecialtyCenterList = Loadable({
  loader: () =>
    import("../_components/zognix/SpecialtyCenter/Center/SpecialtyCenterList"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const ZognixSpecialtyCenterNewList = Loadable({
  loader: () => import("../_components/zognix/SpecialtyCentreNew"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const ZognixSpecialtyCenterProfile = Loadable({
  loader: () => import("../_components/zognix/SpecialtyCentreProfile"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const CardioExperts = Loadable({
  loader: () => import("../_components/cardiologist/WasExperts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AffiliationBio = Loadable({
  loader: () => import("../_components/AffiliationBio"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

//dashboard
const GeneralDashboard = Loadable({
  loader: () => import("../_components/GeneralDashboard"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const GeneralCongresses = Loadable({
  loader: () => import("../_components/Congresses"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const ClassifiedCongresses = Loadable({
  loader: () => import("../_components/ClassifiedCongresses"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const GeneralMedicalBodies = Loadable({
  loader: () => import("../_components/MedicalBodies"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const SocialMediaDemo = Loadable({
  loader: () => import("../_components/Application/OtherMedia"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const Patents = Loadable({
  loader: () => import("../_components/Patents"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

//mld-events
const MldEvents = Loadable({
  loader: () => import("../_components/MldEvents"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

//rare diseases
const MldRareDisease = Loadable({
  loader: () => import("../_components/MldRareDisease"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

//isns
const MldIsns = Loadable({
  loader: () => import("../_components/MldIsns"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

const MldRareDiseaseNetwork = Loadable({
  loader: () => import("../_components/Was/RareDisease/Network"),
  loading: () => (
    <div>
      <Loader />
    </div>
  ),
});

//covid 19
const CovidExperts = Loadable({
  loader: () => import("../_components/Covid/WasExperts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const SampleCriteria = Loadable({
  loader: () => import("../_components/Sample/Criteria"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CovidLocationsSummary = Loadable({
  loader: () => import("../_components/Covid/WasLocations/Summary"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CovidAffiliations = Loadable({
  loader: () => import("../_components/Covid/WasAffiliations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CovidCountryWiseTrials = Loadable({
  loader: () =>
    import("../_components/Covid/WasClinicalTrials/CountryWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CovidExpertsWiseTrials = Loadable({
  loader: () =>
    import("../_components/Covid/WasClinicalTrials/ExpertsWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CovidInstituteWiseTrials = Loadable({
  loader: () =>
    import("../_components/Covid/WasClinicalTrials/InstituteWiseTrials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CovidTrials = Loadable({
  loader: () => import("../_containers/CovidClinicalTrialContainer"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CovidOrganisations = Loadable({
  loader: () => import("../_components/Covid/Organisations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CovidDashboard = Loadable({
  loader: () => import("../_components/Covid/Dashboard"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const CovidCollabNetwork = Loadable({
  loader: () => import("../_components/Covid/CollabNetwork"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

// newborn screening routes
const NewBornExperts = Loadable({
  loader: () => import("../_components/NewBorn/WasExperts"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NewBornLocationsSummary = Loadable({
  loader: () => import("../_components/NewBorn/WasLocations/Summary"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const NewBornAffiliations = Loadable({
  loader: () => import("../_components/NewBorn/WasAffiliations"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

// app specific
const AppTrials = Loadable({
  loader: () => import("../_containers/Applications/Trials"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const AppPublications =  Loadable({
  loader: () => import("../_containers/Applications/Publications"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

/**
 * CHECK FOR THE TOKEN IN LOCAL STORAGE AND VALIDATE THAT TOKEN WITH THE SERVER
 */
let token = localStorage.getItem("token");
let isTokenValid = false;

if (token == "null" || !token) {
  isTokenValid = false;
} else {
  isTokenValid = true;
}

/***
 * GLOBAL AUTH OBJECT
 */
const _AUTH = {
  isAuthenticated: isTokenValid,
  setAuthenticate() {
    this.isAuthenticated = true;
  },
  logout() {
    this.isAuthenticated = false;
  },
};

/***
 *  PROTECTED ROUTER WRAPPERimport React from "react";
import styled from "styled-components";

const Select = styled.select`
  width: 100%;
  background: white;
  padding: 10px;
  border-color: #f1f1f1;
  border-radius: 2px;
  margin-bottom: 10px;
`;

const availableOptions = [
  "Name",
  "Total Articles",
  "Citation",
  "SocMed Score",
  "Clinical Trials",
  "Guidelines",
  "Conferences",
  "Collaborators",
  "First Author",
  "Last Author"
];

const createOption = selected => {
  return availableOptions.map((l, index) => (
    <option key={index} value={l} selected={l === selected}>
      {l}
    </option>
  ));
};

const Sort = props => {
  const options = createOption("Total Articles");

  return (
    <Select onChange={e => props.onSortClick(e.target.value)}>{options}</Select>
  );
};

export default Sort;

 */

const checkToken = () => {
  let token = localStorage.token;
  if (jwtDecode(token).exp < Date.now() / 1000) {
    localStorage.removeItem("token");
    return false;
  }

  return true;
} 

const PrivateRoute = ({
  component: Component,
  // isTokenValid: isTokenValid,
  ...rest
}) => {
  const token = localStorage.getItem("token");
  const isTokenValid = token && token !== "null" && checkToken();

  return (
    <Route
      {...rest}
      render={(props) =>
        isTokenValid === true ? (
          <Component {...props}  timestamp={new Date().toString()}/>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  )
}

/**
 * MAP FEATURES WITH CONTAINER
 *
 */

const featureMap = {
  IP: {
    path: "/app-patent",
    container: PatentNew,
    childrends: [
      // {
      //   path:'/app-patent-map',
      //   container: PatentsMap
      // },
      {
        path: "/app-patent",
        container: PatentNew,
      },
      {
        path: "/expert-bio/:id",
        container: ExpertBioContainer,
      },
    ]
  },
  PROFESSIONALS: {
    path: "/result/experts",
    container: ExpertsContainer,
    childrends: [
      {
        path: "/result/experts/profile-search",
        container: ProfileSearchContainer,
      },
     
      {
        path: "/result/experts/aff-profile-search",
        container: AffiliationBasedProfileContainer,
      },
      {
        path: "/expert-bio/:id",
        container: ExpertBioContainer,
      },
    ],
  },
  PROFILE: {
    path: "/result/direct-profile-search",
    container: DirectProfile,
  },

  LOCATION: {
    path: "/result/location",
    container: LocationContainer,
    childrends: [
      {
        path: "/expert-bio/:id",
        container: ExpertBioContainer,
      },
      {
        path: "/result/location/table",
        container: LocationExpertsTable,
      },
    ],
  },
  "CLINICAL-TRIALS": {
    path: "/result/clinical-trials",
    container: MainTrials,
  },
  "COLLABORATOR-NETWORK": {
    path: "/result/collaborator-network",
    container: CollaboratorNetworkContainer,
    childrends: [
      {
        path: "/expert-bio/:id",
        container: ExpertBioContainer,
      },
      {
        path: "/result/collaborator-network/profile-search",
        container: ProfileSearchCollabContainer,
      },
      {
        path: "/result/collaborator-network/profile",
        container: ProfileBasedCollabsNetwork,
      },
      {
        path: "/result/collaborator-network-profile",
        container: CollaboratorNetworkProfileContainer,
      },
    ],
  },
  TOPIC: {
    path: "/result/topic",
    container: TopicContainer,
    childrends: [
      {
        path: "/expert-bio/:id",
        container: ExpertBioContainer,
      },
      {
        path: "/classified-congresses",
        container: ClassifiedCongresses,
      }
    ],
  },

  "PEER-REVIEWER": {
    path: "/result/peer-review",
    container: PeerReviewer,
    childrends: [
      {
        path: "/expert-bio/:id",
        container: ExpertBioContainer,
      },
    ],
  },

  GRANTS: {
    path: "/result/grants",
    container: GrantsContainer,
  },
  AFFILIATIONS: {
    path: "/result/institutes",
    container: InstituteContainer,
    childrends: [
      {
        path: "/expert-bio/:id",
        container: ExpertBioContainer,
      },
      {
        path: "/aff-bio/:id",
        container: AffBioContainer,
      },
    ],
  },
  ORGANIZATIONS: {
    path: "/result/organisations",
    container: OrganisationsContainer,
  },
  "SOCIAL-MEDIA-SCORE": {
    path: "/result/SocMed",
    container: SocMedContainer,
  },
  "SENIORITY-SCHEMA": {
    path: "/result/Seniority/Schema",
    container: SeniorityProfileContainer,
    childrends: [
      {
        path: "/expert-bio/:id",
        container: ExpertBioContainer,
      },
      {
        path: "/schema-bio/:id",
        container: SenioritySchemaContainer,
      },
    ],
  },
  ROCKET: {
    path: "/rocket-pharma",
    container: RocketPharmaLad,
    childrends: [
      {
        path: "/rocket-pharma/lad",
        container: RocketPharmaLad,
      },
      {
        path: "/rocket-pharma/danon",
        container: RocketPharmaDanon,
      },
      {
        path: "/rocket-pharma/cros",
        container: RocketPharmaCros,
      },
      {
        path: "/rocket-pharma/danon/conf",
        container: RocketPharmaDanonConf,
      },
      {
        path: "/rocket-pharma/danon/m-bodies",
        container: RocketPharmaDanonMBodies,
      },
      {
        path: "/rocket-pharma/lad/conf",
        container: RocketPharmaLadConf,
      },
      {
        path: "/rocket-pharma/lad/m-bodies",
        container: RocketPharmaLadMBodies,
      },
      {
        path: "/rocket-pharma/lad/topics",
        container: RocketPharmaLadTopics,
      },
      {
        path: "/rocket-pharma/danon/topics",
        container: RocketPharmaDanonTopics,
      },
    ],
  },
  ALACRITA: {
    path: "/alacrita",
    container: AlacritaLgmd2c,
    childrends: [
      {
        path: "/alacrita/Lgmd2c",
        container: AlacritaLgmd2c,
      },
      {
        path: "/alacrita/definitions",
        container: AlacritaDefinition,
      },
      {
        path: "/alacrita/trials",
        container: AlacritaTrials,
      },
      {
        path: "/alacrita/epidemiology",
        container: AlacritaEpidemiology,
      },
      {
        path: "/alacrita/trial-sites",
        container: AlacritaTrialSites,
      },
    ],
  },
  ROTA: {
    path: "/rota-application",
    container: RotaApplication,
    childrends: [
      {
        path: "/rota-application/clinician",
        container: RotaApplicationClinician,
      },
      {
        path: "/rota-application/on-call",
        container: RotaApplicationOnCallActivity,
      },
      {
        path: "/rota-application/leave-Details",
        container: RotaApplicationLeaveDetails,
      },
      {
        path: "/rota-application/request-Preview",
        container: RotaApplicationRequestPreview,
      },
      {
        path: "/rota-application/timetable",
        container: RotaApplicationTimeTable,
      },
      {
        path: "/rota-application/requests",
        container: RotaApplicationRequests,
      },
    ],
  },
  "GENERAL-TWEETS": {
    path: "/result/tweets/users",
    container: GeneralTweetsUsers,
    childrends: [
      {
        path: "/result/tweets/handlers",
        container: GeneralTweetsHandler,
      },
    ],
  },
  "CLINICAL-TRIAL-SITES": {
    path: "/result/clinical-trial-sites",
    container: TrialSites,
  },
  "GENERAL-DASHBOARD": {
    path: "/dashboard",
    container: GeneralDashboard,
  },
  "GENERAL-CONGRESS": {
    path: "/congresses",
    container: GeneralCongresses,
  },
  "GENERAL-PAG": {
    path: "/medical-bodies",
    container: GeneralMedicalBodies,
  },
  "GENERAL-PATENT": {
    path: "/patents",
    container: Patents,
  },
  "CONCEPT-MAPPING": {
    path: "/concept-mapping",
    container: ConceptMapping,
  },
  "RELATED-CONCEPTS": {
    path: "/related-concepts",
    container: RelatedConcepts,
  },
  "PERSON-SIMILARITY": {
    path: "/people-similarity",
    container: PersonSimilarity,
  },
  "METACHROMATIC-LEUKODYSTROPHY": {
    path: "/mld-professionals/short-listed",
    container: MldProfessionals,
    childrends: [
      {
        path: "/app-contacts",
        container: Contacts,
      },
      {
        path: "/app-summary",
        container: AppHome,
      },
      {
        path: "/app-events-network",
        container: EventsNetwork,
      },
      {
        path: "/mld-dashboard",
        container: MldDashboard,
      },
      {
        path: "/mld-locations",
        container: MldLocations,
      },
      // {
      //   path: "/mld-professionals/short-listed",
      //   container: MldShortList
      // // },
      // {
      //   path: "/mld-professionals/selected-list",
      //   container: MldSelectedList
      // },
      // {
      //   path: "/mld-professionals/removed-short-list",
      //   container: MldRemovedShortList
      // },
      {
        path: "/mld-social",
        container: MldSocial,
      },
      {
        path: "/ern",
        container: ErnNetwork,
      },
      {
        path: "/mld-conf",
        container: MldConf,
      },
      {
        path: "/mld-trials",
        container: MldTrials,
      },
      {
        path: "/mld-institutes",
        container: MldAffiliations,
      },
      {
        path: "/mld-collaborator-network",
        container: MldCollbsNetwork,
      },
      {
        path: "/mld-definitions",
        container: MldDefinition,
      },
      {
        path: "/mld-trials-country-wise",
        container: CountryWiseTrials,
      },
      {
        path: "/mld-trials-experts-wise",
        container: ExpertsWiseTrials,
      },
      {
        path: "/mld-trials-institute-wise",
        container: InstituteWiseTrials,
      },
      {
        path: "/mld-summary",
        container: MldSummary,
      },
      {
        path: "/mld-social-media",
        container: MldSocialMedia,
      },
      {
        path: "/mld-locations-summary",
        container: MldLocationsSummary,
      },
      {
        path: "/mld-medical-bodies",
        container: MldMedicalBodies,
      },
      {
        path: "/mld-social-media",
        container: MldTweetsSummary,
      },
      {
        path: "/mld-social-media/related-users",
        container: MldTweetsRelatedUsers,
      },
      {
        path: "/mld-social-media/related-terms",
        container: MldTweetsRelatedTerms,
      },
      {
        path: "/mld-social-media/sentiment",
        container: MldTweetsSentiment,
      },
      {
        path: "/mld-social-media/users",
        container: MldTweetsUsers,
      },
      {
        path: "/mld-social-media/twitter-handler",
        container: MldTweetsHandler,
      },
      {
        path: "/raredisease-event",
        container: MldRareDisease,
      },
      {
        path: "/isns",
        container: MldIsns,
      },
      {
        path: "/app-events",
        container: MldEvents,
      },
      {
        path: "/raredisease-network",
        container: MldRareDiseaseNetwork,
      },
    ],
  },
  // "BLUEBIRD": {
  //   path: "/ald-professionals",
  //   container: AldProfessionals,
  //   childrends: [
  //     {
  //       path: "/ald-locations",
  //       container: AldLocations
  //     },
  //     {
  //       path: "/ald-professionals/short-listed",
  //       container: AldShortList
  //     },
  //     {
  //       path: "/ald-professionals/selected-list",
  //       container: AldSelectedList
  //     },
  //     {
  //       path: "/ald-professionals/removed-short-list",
  //       container: AldRemovedShortList
  //     },
  //     {
  //       path: "/ald-social",
  //       container: AldSocial
  //     },
  //     {
  //       path: "/ERN",
  //       container: ERN_Network
  //     },
  //     {
  //       path: "/ald-conf",
  //       container: AldConf
  //     },
  //     {
  //       path: "/ald-trials",
  //       container: AldTrials
  //     },
  //     {
  //       path: "/ald-institutes",
  //       container: AldAffiliations
  //     },
  //     {
  //       path: "/ald-collaborator-network",
  //       container: AldCollbsNetwork
  //     },
  //     {
  //       path: "/ald-definitions",
  //       container: AldDefinition
  //     },
  //     {
  //       path: "/ald-trials-country-wise",
  //       container: CountryWiseTrials
  //     },
  //     {
  //       path: "/ald-trials-experts-wise",
  //       container: ExpertsWiseTrials
  //     },
  //     {
  //       path: "/ald-trials-institute-wise",
  //       container: InstituteWiseTrials
  //     },
  //     {
  //       path: "/ald-summary",
  //       container: AldSummary
  //     },
  //     {
  //       path: "/ald-locations-summary",
  //       container: AldLocationsSummary
  //     },
  //     {
  //       path: "/ald-medical-bodies",
  //       container: AldMedicalBodies
  //     }
  //   ]
  // },

  NIPT: {
    path: "/nipt-experts",
    container: NiptProfessionals,
    childrends: [
      /*** NEW NIPT ROUTES */
      {
        path: "/niptapp-experts",
        container: NiptAppExperts,
      },
      {
        path: "/niptapp-institutes",
        container: NiptAppAffiliations,
      },
      {
        path: "/niptapp-locations-summary",
        container: NiptAppLocations,
      },
      {
        path: "/niptapp-definitions",
        container: NiptappDefinitions,
      },
      {
        path: "/niptapp-summary",
        container: NiptappSummary,
      },

      {
        path: "/niptapp-collaborator-network",
        container: NiptappCollabNetwork,
      },
      ,
      {
        path: "/niptapp-trials",
        container: NiptappTrials,
      },

      {
        path: "/niptapp-trials-country-wise",
        container: NiptappCountryWiseTrials,
      },
      {
        path: "/niptapp-trials-experts-wise",
        container: NiptappExpertsWiseTrials,
      },
      {
        path: "/niptapp-trials-institute-wise",
        container: NiptappInstituteWiseTrials,
      },

      // /***END */
      {
        path: "/niptapp-medical-bodies",
        container: NiptMedicalBodies,
      },
      {
        path: "/niptapp-conf",
        container: NiptConf,
      },

      {
        path: "/niptapp-funding-org",
        container: NiptFundingOrg,
      },

      // {
      //   path: "/nipt-professionals/short-listed",
      //   container: NiptShortList
      // },
      // {
      //   path: "/nipt-professionals/selected-list",
      //   container: NiptSelectedList
      // },
      // {
      //   path: "/nipt-institutes",
      //   container: NiptAffiliations
      // },
      // {
      //   path: "/nipt-locations",
      //   container: NiptLocations
      // },
      // {
      //   path: "/nipt-collaborator-network",
      //   container: NiptCollbsNetwork
      // },
      // {
      //   path: "/nipt-definitions",
      //   container: NiptDefinition
      // },
      // {
      //   path: "/nipt-summary",
      //   container: NiptSummary
      // },
      // {
      //   path: "/nipt-locations-summary",
      //   container: NiptLocationsSummary
      // },
      // {
      //   path: "/nipt-trials",
      //   container: NiptTrials
      // },
      // {
      //   path: "/nipt-trials-country-wise",
      //   container: NiptCountryWiseTrials
      // },
      // {
      //   path: "/nipt-trials-experts-wise",
      //   container: NiptExpertsWiseTrials
      // },
      // {
      //   path: "/nipt-trials-institute-wise",
      //   container: NiptInstituteWiseTrials
      // },
      // {
      //   path: "/nipt-grants",
      //   container: NiptGrants
      // }
    ],
  },

  "RELATIONSHIP-MAPPING": {
    path: "/relationship-mapping",
    name: "RELATIONSHIP MAPPING",
    container: KolMapping,
    childrends: [
      {
        path: "/relationship-mapping/upload",
        name: "RELATIONSHIP MAPPING UPLOAD",
        container: KolUpload,
      },
    ],
  },
  "CLINICALTRIALS-INSTITUTES": {
    path: "/trials/institutes",
    name: "CLINICAL TRIALS SPONSORS AND RECRUITERS",
    container: Trials,
  },
  "CLINICALTRIALS-OUTCOMES": {
    path: "/trials/end-points",
    name: "CLINICAL TRIALS OUTCOME MEASURES",
    container: TrialsEndPoints,
  },
  "CLINICALTRIALS-PHASES": {
    path: "/trials/phases",
    name: "DRUG AND PHASES",
    container: TrialsPhases,
  },
  "NEWBORN-SCREENING": {
    path: "/newborn-experts",
    container: NewBornExperts,
    childrends: [
      {
        path: "/newborn-locations-summary",
        container: NewBornLocationsSummary,
      },

      {
        path: "/newborn-institutes",
        container: NewBornAffiliations,
      },
    ],
  },

  "WISKOTT-ALDRICH-SYNDROME": {
    path: "/was-experts",
    container: WasExperts,
    childrends: [
      {
        path: "/was-dashboard",
        container: WasDashboard,
      },
      {
        path: "/was-locations-summary",
        container: WasLocationsSummary,
      },

      {
        path: "/was-conf",
        container: WasConfs,
      },
      {
        path: "/was-trials",
        container: WasTrials,
      },

      {
        path: "/was-trials-country-wise",
        container: WasCountryWiseTrials,
      },
      {
        path: "/was-trials-experts-wise",
        container: WasExpertsWiseTrials,
      },
      {
        path: "/was-trials-institute-wise",
        container: WasInstituteWiseTrials,
      },
      {
        path: "/was-institutes",
        container: WasAffiliations,
      },
      {
        path: "/was-collaborator-network",
        container: WasCollabNetwork,
      },

      {
        path: "/was-definitions",
        container: WasDefinitions,
      },
      {
        path: "/was-summary",
        container: WasSummary,
      },

      {
        path: "/was-medical-bodies",
        container: WasMedicalBodies,
      },
      {
        path: "/was-social-media/users",
        container: WasTweetsUsers,
      },
      {
        path: "/was-social-media/twitter-handler",
        container: WasTweetsHandler,
      },
    ],
  },
  "THERAPEUTIC-AREA-A": {
    path: "/app-expert-summary",
    container: AppExpertSummary,
    childrends: [
      {
        path: "/institute",
        container: AffiliationBio,
      },
      {
        path: "/app-experts",
        container: ZognixExperts,
      },
      {
        path: "/app-dashboard",
        container: ZognixDashboard,
      },
      {
        path: "/app-locations-summary",
        container: AppLocationsSummary,
      },

      {
        path: "/app-conf",
        container: AppCongresses,
      },
      {
        path: "/app-publications",
        container: AppPublications,
      },

      {
        path: "/app-trials",
        container: AppTrials,
      },

      {
        path: "/app-trials-country-wise",
        container: ZognixCountryWiseTrials,
      },
      {
        path: "/app-trials-experts-wise",
        container: ZognixExpertsWiseTrials,
      },
      {
        path: "/app-trials-institute-wise",
        container: ZognixInstituteWiseTrials,
      },
      {
        path: "/app-institutes",
        container: AppAffiliations,
      },
      {
        path: "/app-collaborator-network",
        container: AppCollabNetwork,
      },
      {
        path: "/app-definitions",
        container: AppDefinitions,
      },
      {
        path: "/app-medical-bodies",
        container: AppMedicalBodies,
      },
      {
        path: "/app-social-media/users",
        container: ZognixTweetsUsers,
      },
      {
        path: "/app-social-media/twitter-handler",
        container: ZognixTweetsHandler,
      },
    ],
  },
  D2L_SAMPLE: {
    path: "/app-expert-summary",
    container: AppExpertSummary,
    childrends: [
      {
        path: "/app-institutes",
        container: AppAffiliations,
      },
      {
        path: "/app-locations-summary",
        container: AppLocationsSummary,
      },
      {
        path: "/app-trials",
        container: AppTrials,
      },
      {
        path: "/app-collaborator-network",
        container: AppCollabNetwork,
      },
    ],
  },
  HYPERTROPHIC_CARDIOMYOPATHY: {
    path: "/app-expert-summary",
    container: AppExpertSummary,
    childrends: [
      {
        path: "/app-institutes",
        container: AppAffiliations,
      },
      {
        path: "/app-locations-summary",
        container: AppLocationsSummary,
      },
      {
        path: "/app-trials",
        container: AppTrials,
      },
      {
        path: "/app-conf",
        container: AppCongresses,
      },
      {
        path: "/app-medical-bodies",
        container: AppMedicalBodies,
      },
      {
        path: "/app-collaborator-network",
        container: AppCollabNetwork,
      },
      {
        path: "/app-social-media",
        container: AppSocialMedia,
      },
      {
        path: "/app-definitions",
        container: AppDefinitions,
      },
    ],
  },
  "SPECIALTY-CENTER": {
    path: "/app-specialtycentre",
    container: ZognixSpecialtyCenterNewList,
    childrends: [
      {
        path: "/app-specialtycentre/table",
        container: ZognixSpecialtyCenterTable,
      },
      {
        path: "/app-specialtycentre/list",
        container: ZognixSpecialtyCenterList,
      },
      {
        path: "/app-hco",
        container: ZognixSpecialtyCenterNewList,
      },
      {
        path: "/hco/:id",
        container: ZognixSpecialtyCenterProfile,
      },
    ],
  },
  CARDIOLOGIST: {
    path: "/cardio-experts",
    container: CardioExperts,
    childrends: [],
  },
  "COVID-19": {
    path: "/covid-19-experts",
    container: CovidExperts,
    childrends: [
      {
        path: "/covid-19-collaborator-network",
        container: CovidCollabNetwork,
      },
      {
        path: "/covid-19-dashboard",
        container: CovidDashboard,
      },
      {
        path: "/covid-19-locations-summary",
        container: CovidLocationsSummary,
      },

      {
        path: "/covid-19-trials",
        container: CovidTrials,
      },
      {
        path: "/covid-19-orgs",
        container: CovidOrganisations,
      },
      {
        path: "/covid-19-trials-country-wise",
        container: CovidCountryWiseTrials,
      },
      {
        path: "/covid-19-trials-experts-wise",
        container: CovidExpertsWiseTrials,
      },
      {
        path: "/covid-19-trials-institute-wise",
        container: CovidInstituteWiseTrials,
      },
      {
        path: "/covid-19-institutes",
        container: CovidAffiliations,
      },
      {
        path: "/expert-bio/:id",
        container: ExpertBioContainer,
      },
    ],
  },
  "CLEARVIEW-SAMPLE": {
    path: "/sample-criteria",
    container: SampleCriteria,
  },
};

import {
  changeUserFeatures,
  changeModuleId,
  changeModule,
  changeModulesList,
} from "../actions/userAccessCheck";
import jwt_decode from "jwt-decode";
import { USER_TRACK_API } from "../constants/_api";
import verifyRoute from "./verifyRoute";
// import { record } from "rrweb";

// let fetchURL = `http://localhost:7000`;

// import socketIOClient from "socket.io-client";
// let socket, REQ_URL = window.location.hostname;

class AppRouter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTokenValid: false,
      isLoading: true,
      currentTimeStamp: null,
      isRedirectToHome: false,
      // endpoint: REQ_URL
    };
    // socket = socketIOClient(REQ_URL);
  }

  // esRecord = async (body) => {
  // let pathname = window.location.pathname;
  // if (pathname !== "/player-dashboard" && pathname !== "/main-player") {
  //   let esResult = await fetch(USER_TRACK_API, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json"
  //     },
  //     body
  //   })
  //   esResult = await esResult.json();
  //   return esResult;
  // }
  //   return "Not recording for Player!" ;
  // }

  // saveUserIntraction = async () => {
  //   try {
  //     if (window.events.length > 0) {

  //       let uniqueId = ""
  //       let { currentTimeStamp } = this.state;

  //       try {
  //         let token = localStorage.getItem("token");
  //         if (token) {
  //           let parsedToken = jwt_decode(token);
  //           uniqueId = parsedToken.unique_id;
  //         }
  //       } catch (err) {
  //         console.log(err);
  //       }

  //       let sessionId = `${uniqueId}-${currentTimeStamp}`;

  //       let events = window.events.map(l => ({
  //         ...l,
  //         uniqueId,
  //         sessionId
  //       }))

  //       let body = JSON.stringify({ events });
  //       // await socket.emit("events", body);

  //       let data = await this.esRecord(body);
  //       console.log(data);

  //       // Promise.resolve(this.esRecord(body))
  //       // .then(data => console.log(data))
  //       // .catch(err => console.log(err));

  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }

  //   window.events = [];
  // };

  // componentWillUnmount() {

  //   window.events = [];
  //   try {
  //     window.clearInterval(window.trackTimerId);
  //   } catch (err) {
  //     console.log(err);
  //   }

  // }

  // componentDidMount() {

  //   let currentTimeStamp = Date.now();
  //   this.setState({ currentTimeStamp }, () => console.log(this.state.currentTimeStamp));

  //   window.events = [];
  //   window.saveUserIntraction = this.saveUserIntraction
  //   window.stopFn = record({

  //     emit(event) {
  //       console.log(event)
  //       // window.events.push(event);
  //       // window.saveUserIntraction();
  //     }
  //   });
  //   window.trackTimerId = setInterval(this.saveUserIntraction, 1 * 1000);
  // }

  componentDidMount() {
    this.validateUserToken(token);
  }

  componentWillReceiveProps(props) {
    this.setState({
      isTokenValid: props.isLoggedIn,
    });

    if (props.isLoggedIn) {
    }
  }

  storeRedirectUrl = () => {
    try {
      //escape login urls
      if (
        window.location.pathname.indexOf("login") === -1 &&
        window.location.pathname.indexOf("app-home") === -1 &&
        window.location.pathname !== "/" &&
        window.location.pathname.indexOf("redirect-token") === -1
      ) {
        // //store incomming url
        // let incommingPath =  window.location.origin + window.location.pathname?window.location.pathname:'' + window.location.search?window.location.search:'';
        // console.log(incommingPath, 'incommingPath')
        let incommingPath = window.location.href;
        window.localStorage.setItem("redirect_url", incommingPath);
      }
    } catch (err) {
      console.log(err);
    }
  };

  validateUserToken = (token) => {
    // fetch(`${ROOT_URL}/api/istoken-valid`, {
    //   method: "GET",
    //   headers: {
    //     "Content-Type": "application/json",
    //     "Access-Control-Allow-Origin": "*",
    //     "Access-Control-Allow-Headers": "X-Requested-With",
    //     "Content-Type": "application/json",
    //     "x-access-token": token,
    //   },
    // })
    //   .then((res) => res.json())
    //   .then((res) => {
    //     // console.log(res.body);
    //     if (res.message !== "token_valid") {
    //       this.storeRedirectUrl();

    //       /* CLEAR THE INVALID TOKEN */
    //       this.setState({
    //         isLoading: false,
    //         isTokenValid: false,
    //       });
    //     } else {
    //       if (res.body && res.body.features) {
    //         let features = res.body.features;
    //         this.props.changeUserFeatures(features);
    //         return this.setState({
    //           isLoading: false,
    //           isTokenValid: true,
    //         });
    //       } else {
    //         /* CLEAR THE INVALID TOKEN */
    //         localStorage.setItem("token", "null");
    //         this.setState({
    //           isLoading: false,
    //           isTokenValid: false,
    //         });
    //       }
    //     }
    //   })
    fetch(`${ROOT_URL}/api/app/user-infos`, {
      method: "POST",
      // body: JSON.stringify({ moduleId: "DSLGS" }),
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "X-Requested-With",
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.message !== "success") {
          this.storeRedirectUrl();

          /* CLEAR THE INVALID TOKEN */
          this.setState({
            isLoading: false,
            isTokenValid: false,
          });
        } else {
          let path = window.location.pathname + window.location.search;
          if (res.body && res.body.infos) {
            let {
              changeUserFeatures,
              changeModule,
              changeModulesList,
              changeModuleId,
            } = this.props;
            let { features = [], modules = [] } = res.body.infos || {};
            changeUserFeatures(features);
            changeModulesList(modules);

            try {
              let redirect_url = window.localStorage.getItem("redirect_url");
              if (redirect_url) {
                if (redirect_url !== "null") {
                  window.localStorage.setItem("redirect_url", "null");
                  window.location.href = redirect_url;
                  return;
                }
              }
            } catch (err) {
              console.log(err);
              window.localStorage.setItem("redirect_url", "null");
            }

            let verifiedData = verifyRoute(path, modules);
            let {
              moduleId = "",
              moduleObject = {},
              link = "",
              isRedirectToHome,
            } = verifiedData;


            if (isRedirectToHome) {
              changeModuleId(moduleId);
              changeModule(moduleObject);
            } else {
              changeModuleId(moduleId);
              changeModule(moduleObject);
            }

            return this.setState({
              isLoading: false,
              isTokenValid: true,
              isRedirectToHome,
            });
          } else {
            /* CLEAR THE INVALID TOKEN */
            localStorage.setItem("token", "null");
            this.setState({
              isLoading: false,
              isTokenValid: false,
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
        /* CLEAR THE INVALID TOKEN */
        localStorage.setItem("token", "null");
        this.setState({
          isLoading: false,
          isTokenValid: false,
        });
      });
  };

  render() {
    let isTokenValid = this.props.isLoggedIn;
    let { features } = this.props;
    let { isRedirectToHome } = this.state;

    if (!isTokenValid) {
      this.storeRedirectUrl();
    }

    if (this.state.isLoading) {
      return (
        <div>
          <div>
            <Loader />
          </div>
        </div>
      );
    }

    //create user routes based on user features
    let userFeatures = [];
    let uniqueRoutes = [];
    features.forEach((feature, index) => {
      let l = featureMap[feature];

      if (l) {
        //check path alread exists or not
        if (uniqueRoutes.indexOf(l.path) !== -1) {
          return;
        } else {
          uniqueRoutes.push(l.path);
        }

        let userRoute = (
          <PrivateRoute
            key={l.path}
            isTokenValid={isTokenValid}
            path={l.path}
            component={WithTracker(l.container)}
            exact
          />
        );

        userFeatures.push(userRoute);

        //check if each features has children routes
        if (l.childrends) {
          l.childrends.forEach((child, index) => {
            //check path alread exists or not
            if (uniqueRoutes.indexOf(child.path) !== -1) {
              return;
            } else {
              uniqueRoutes.push(child.path);
            }

            let userRoute = (
              <PrivateRoute
                key={child.path}
                isTokenValid={isTokenValid}
                path={child.path}
                component={WithTracker(child.container)}
                exact
              />
            );

            userFeatures.push(userRoute);
          });
        }
      }
    });

    return (
      <BrowserRouter>
        {/* {isRedirectToHome && <Redirect to="/app-home" />} */}
        <div>
          <GlobalStyles />
          <CookieConsent
            style={{
              background: "black",
              textShadow: "2px 2px black",
              paddingRight: "250px",
            }}
            buttonStyle={{
              fontWeight: 700,
              fontSize: "0.9em",
              padding: ".4em .8em",
            }}
            buttonText={"Accept & Close"}
            debug={false}
          >
            LAYERIV uses cookies for functional and analytical purposes. Please
            read our <Link to="cookie-policy">Cookie Policy</Link> for more
            information.
          </CookieConsent>
          {/* <Alert stack={{ limit: 5 }} /> */}

          <Switch>
            <Route path="/" component={WithTracker(LoginContainer)} exact />

            <Route
              path="/register/user"
              component={WithTracker(RegisterInfo)}
              exact
            />
            <Route
              path="/reset-password"
              component={WithTracker(ResetPassword)}
              exact
            />
            <Route
              path="/forgot-password"
              component={WithTracker(ForgetPassword)}
              exact
            />
            <Route
              path="/privacy"
              component={WithTracker(PrivacyPolicy)}
              exact
            />
            <Route
              path="/terms"
              component={WithTracker(TermsOfService)}
              exact
            />
            <Route path="/gdpr" component={WithTracker(GDBR)} exact />
            <Route
              path="/service-privacy"
              component={WithTracker(ServicePolicy)}
              exact
            />
            <Route
              path="/reasonableusepolicy"
              component={WithTracker(ResonableUsePolicy)}
              exact
            />
            <Route
              path="/cookie-policy"
              component={WithTracker(CookiePolicy)}
              exact
            />
            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/schema-bio/:id"
              component={WithTracker(SenioritySchemaContainer)}
              exact
            />
            {/* http://localhost:8080/app-spain-scoial-media?moduleId=SPAIN_SOCIAL_MEDIA */}
            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-spain-social-media"
              component={WithTracker(SpainSocialMedia)}
              exact
            />
             <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-spain-social-media-esl"
              component={WithTracker(SpainSocialMediaEsl)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-spain-social-media/profile/:id"
              component={WithTracker(SpainSocialMediaProfile)}
              exact
            />
            

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/result/experts/multi-search"
              component={WithTracker(ExpertMultiSearchContainer)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/my-account"
              component={WithTracker(MyAccount)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/security"
              component={WithTracker(MyAccount)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/preferences"
              component={WithTracker(MyAccount)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota/doctors/my-details"
              component={WithTracker(RotaDoctorsMyDetails)}
              exact
            />
            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota/doctors/clinic-list"
              component={WithTracker(RotaDoctorsClinicList)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota/doctors/oncall-list"
              component={WithTracker(RotaDoctorsOnCallList)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota/doctors/leave-list"
              component={WithTracker(RotaDoctorsLeaveList)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota/doctors/time-table"
              component={WithTracker(RotaDoctorsTimeTable)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota"
              component={WithTracker(RotaLanding)}
              exact
            />

            {
              <PrivateRoute
                isTokenValid={isTokenValid}
                path="/rota-application"
                component={WithTracker(RotaApplication)}
                exact
              />
            }

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota-application/clinician"
              component={WithTracker(RotaApplicationClinician)}
              exact
            />
            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota-application/on-call"
              component={WithTracker(RotaApplicationOnCallActivity)}
              exact
            />
            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota-application/leave-details"
              component={WithTracker(RotaApplicationLeaveDetails)}
              exact
            />
            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota-application/timetable"
              component={WithTracker(RotaApplicationTimeTable)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota-application/request-details"
              component={WithTracker(RotaApplicationRequestDetails)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota-application/request-preview"
              component={WithTracker(RotaApplicationRequestPreview)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/rota-application/requests"
              component={WithTracker(RotaApplicationRequests)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/liv/app/home"
              component={WithTracker(AppSpecificHomePage)}
              exact
            />
            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/sources"
              component={WithTracker(Sources)}
              exact
            />

            {/* <Route
              path="/register"
              component={WithTracker(RegisterContainer)}
              exact
            /> */}
            <Route
              path="/login"
              component={WithTracker(LoginContainer)}
              exact
            />

            {/* Application Specific Common Routes */}

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-home"
              component={WithTracker(Landing)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/social-media-demo"
              component={WithTracker(SocialMediaDemo)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-expert-summary"
              component={WithTracker(AppExpertSummary)}
              exact
            />
              <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-expert-summary-top"
              component={WithTracker(AppExpertSummaryTop)}
              exact
            />

<PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-expert-summary-all"
              component={WithTracker(AppExpertSummaryAll)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-experts"
              component={WithTracker(ZognixExperts)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-institutes"
              component={WithTracker(AppAffiliations)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-locations-summary"
              component={WithTracker(AppLocationsSummary)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-trials"
              component={WithTracker(AppTrials)}
              exact
            />

<PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-publications"
              component={WithTracker(AppPublications)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-conf"
              component={WithTracker(AppCongresses)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-medical-bodies"
              component={WithTracker(AppMedicalBodies)}
              exact
            />

<PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-medical-society"
              component={WithTracker(AppMedicalSociety)}
              exact
            />

<PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-patient-advocacy-group"
              component={WithTracker(AppPatientAdvocacy)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-collaborator-network"
              component={WithTracker(AppCollabNetwork)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-social-media"
              component={WithTracker(AppSocialMedia)}
              exact
            />
            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-social-media/profiles"
              component={WithTracker(AppSocialMedia)}
              exact
            />

            <PrivateRoute
              isTokenValid={isTokenValid}
              path="/app-definitions"
              component={WithTracker(AppDefinitions)}
              exact
            />

            {/* Application Specific Common Routes */}

            <Route
              path="/redirect-token"
              component={WithTracker(LoginRedirect)}
              exact
            />
            <Route path="/help" component={WithTracker(Help)} exact />

            {userFeatures}

            <Redirect to={`/login`} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => ({
  error: state.login.error,
  message: state.login.message,
  isLoggedIn: state.Global.isLoggedIn,
  features: state.Global.features,
  token: state.Global.token,
  moduleId: state.Global.moduleId,
  modulesList: state.Global.modulesList,
});

export default connect(mapStateToProps, {
  changeUserFeatures,
  changeModuleId,
  changeModule,
  changeModulesList,
})(AppRouter);
